import React from 'react';
import { Provider, observer, inject } from 'mobx-react';
import { IntlProvider } from 'react-intl';
import RootStore from './my_meetings_components/stores/MyMeetingsStore';
import LocaleStore from './common_components/localization/LocaleStore';
import igmeetingsLocales from '../locales/igmeetings.json';
import defaultLocales from '../locales/default.json';
import Main from './my_meetings_launcher_components/Main';

// ////// Use Mobx-react-devtools only in development environment ///////////
let DevTools;
if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
  DevTools = require('mobx-react-devtools').default;
} else {
  DevTools = () => null;
}
// //////////////////////////////////////////////////////////////////////////

export default class MyMeetingsLauncher extends React.Component {
  constructor(props) {
    super(props);
    // this.rootStore = new RootStore();
  }

  render() {
    const { userLocale } = this.props;
    const messages = {
      ...igmeetingsLocales[userLocale],
      ...defaultLocales[userLocale],
    };
    return (
      <Provider rootStore={this.rootStore}>
        <IntlProvider locale={userLocale} messages={messages}>
          <Main currentUser={this.props.currentUser} />
        </IntlProvider>
      </Provider>
    );
  }
}
